import manualData from '../../data/Manualdata';

import { useIdioma } from '../../context/IdiomaContext';

import './ManualInicio.css';

function ManualInicio() {
  const { t } = useIdioma();

  return (
    <section className="manuales">
      <h2>
        {t('manualInicio.titulo')}
      </h2>

      <div className="manuales-container">
        {manualData.map((item) => (
          <a
            href={item.pdf}
            download={item.archivo}
            className="manuales-card"
            key={item.nombre}
            aria-label={`${t(
              'manualInicio.descargar'
            )} ${item.nombre} ${t(
              'manualInicio.enPdf'
            )}`}
          >
            <img
              src={item.logo}
              alt={`${t(
                'manualInicio.portada'
              )} ${item.nombre}`}
            />

            <span className="manual-titulo">
              {item.nombre}
            </span>

            <span className="manual-autor">
              {t(
                `manualInicio.autores.${item.autor}`
              )}
            </span>

            <span className="manual-descarga">
              {t(
                'manualInicio.descargarPdf'
              )}{' '}
              ↓
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}

export default ManualInicio;